import { Injectable } from '@angular/core';
import { Effect, Actions } from '@ngrx/effects';
import { Observable } from 'rxjs';

import {
    GetLeaderboardSuccess,
    GetLeaderboardFailure,
    GET_LEADERBOARD,
    UpdateCountryLeaderboard,
    GET_COUNTRY_LEADERBOARDS,
    GetCountryLeaderboardsSuccess,
    GetCountryLeaderboardsFailure
} from '../actions/leaderboard.actions';
import { ApiService } from '../../services';
import { TOGGLE_FILTER_TYPE, UPDATE_COUNTRY_FILTER, UPDATE_FILTER } from '../actions/filter.actions';
import { Store } from '@ngrx/store';
import { State } from '../reducers';
import { defaultState as defaultFilterState } from '../reducers/filter.reducer';
import { getCountryLeaderboardsData, getFilterFilter } from '../selectors/selectors';
import { CountryLeaderboard, CountryLeaderboardsData, FilterModel } from '../../models';

const getFilteredCountryLeaderboard = (countryLeaderboardsData: CountryLeaderboardsData, filter: FilterModel) => {
  return Object.keys(filter.types).reduce((acc, type) => {
    if (filter.types[type]) { // barrier type is selected
      const currentLeaderboard = countryLeaderboardsData[type];
      for (const country of Object.keys(currentLeaderboard)) {
        if (acc[country]) {
          acc[country] += currentLeaderboard[country];
        } else {
          acc[country] = currentLeaderboard[country];
        }
      }
    }
    return acc;
  }, {});
};

@Injectable()
export class LeaderboardEffects {

    @Effect() get$ = this.actions$
        .ofType(GET_LEADERBOARD)
        .switchMap(() => this.api.getLeaderboard()
            .mergeMap(users => Observable.of(new GetLeaderboardSuccess(users)))
            .catch(err => Observable.of(new GetLeaderboardFailure(err)))
    );

    @Effect() getFilteredLeaderboard$ = this.actions$
    .ofType(UPDATE_FILTER, UPDATE_COUNTRY_FILTER, TOGGLE_FILTER_TYPE)
    .withLatestFrom(this.store.select(state => state.filter.filter))
    .switchMap(([_, filter]) => this.api.getLeaderboard(filter)
      .mergeMap(users => Observable.of(new GetLeaderboardSuccess(users)))
      .catch(err => Observable.of(new GetLeaderboardFailure(err)))
    );

    @Effect() getCountryLeaderboard$ = this.actions$
        .ofType(GET_COUNTRY_LEADERBOARDS)
        .switchMap(() => this.api.getCountryLeaderboards()
          .mergeMap(countryLeaderboardsData => {
            const leaderboard = getFilteredCountryLeaderboard(countryLeaderboardsData, defaultFilterState.filter);
            return Observable.of(new GetCountryLeaderboardsSuccess(countryLeaderboardsData, leaderboard));
          })
          .catch(err => Observable.of(new GetCountryLeaderboardsFailure(err)))
    );


    @Effect() updateCountryLeaderboard$ = this.actions$
    .ofType(UPDATE_FILTER, TOGGLE_FILTER_TYPE)
    .combineLatest(this.store.select(getFilterFilter), this.store.select(getCountryLeaderboardsData))
      .switchMap(([_, filter, leaderboardsData]) => {
        const leaderboard: CountryLeaderboard = getFilteredCountryLeaderboard(leaderboardsData, filter);
        return Observable.of(new UpdateCountryLeaderboard(leaderboard));
      }
    );

    constructor (
        private actions$: Actions,
        private api: ApiService,
        private store: Store<State>
    ) { }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/core/store/effects/leaderboard.effects.ts